import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferTabView from 'buffers/BufferTabView';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import BulkAssemblyOverviewTabState from 'molbio/bulk-assembly/backbone/BulkAssemblyOverviewTabState';
import BulkAssemblyOverviewTab from 'molbio/bulk-assembly/overview-tab/BulkAssemblyOverviewTab';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

export default class BulkAssemblyOverviewTabView extends BufferTabView<BulkAssemblyOverviewTabState> {
  reactRoot: ReactDOM.Root | null = null;

  override render(): this {
    this.reactRoot = renderToDOM(
      <BulkAssemblyOverviewTab
        assemblyId={this.model.bulkAssemblyModel().id}
        onSetName={(name) => this.onSetName(name)}
        onSetFolder={(folderId) => {
          this.onSetFolder(folderId);
        }}
      />,
      this.el,
      this.reactRoot
    );
    return this;
  }

  async onSetName(name: string): Promise<void> {
    await this.model.bulkAssemblyModel().triggerUpdateNameAction(name);
  }

  onSetFolder(folderId: string): void {
    FileBrowserActions.moveItemsWithDataMods([this.model.bulkAssemblyModel().id], folderId, {
      parentFolderIds: [this.model.bulkAssemblyModel().folder().id],
      hasRegisteredItems: false,
    });
  }

  override removeAsync(callback: () => void): this {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}
